import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "component/ui/Button";
import { ConfettiSuccessIcon } from "asset/icons";

const SuccessfullyUpdatedOnboarding = ({ onDashboardClick }) => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    if (onDashboardClick) {
      onDashboardClick();
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="min-h-screen w-full bg-[#FAFAFC] flex flex-col items-center justify-center px-4 py-12 select-none">
      <div className="flex flex-col space-y-3 items-center text-center max-w-[480px] w-full">
        {/* Confetti & Checkmark Illustration */}
        <div className="flex justify-center items-center mb-3">
          <ConfettiSuccessIcon className="w-36 h-36 md:w-44 md:h-44 shrink-0" />
        </div>

        {/* Headline */}
        <h1 className="text-xl md:text-[24px] font-semibold text-[#101828] tracking-tight">
          We’ve received your information
        </h1>

        {/* Subtitle */}
        <p className="text-sm md:text-[14px] text-[#667085] leading-[1.6] max-w-[410px] font-normal">
          Thank you. Your business profile will be updated with the additional information after it's reviewed.
        </p>

        {/* Shadcn Button */}
        <Button
          onClick={handleGoToDashboard}
          className="text-white font-medium text-sm px-6 h-11 rounded-lg shadow-none transition-colors border-none cursor-pointer"
        >
          Go to your dashboard
        </Button>
      </div>
    </div>
  );
};

export default SuccessfullyUpdatedOnboarding;